export const WEBPOS_INFO_KEY = 'WEBPOS_INFO'
export const WEBPOS_SESSION_ACTIVE_KEY = 'WEBPOS_SESSION_ACTIVE'

const WEBPOS_HOSTS = ['webpos-uatcandao.phd.hk', 'webpos.phd.hk']
const WEBPOS_DEBUG_HOSTS = ['localhost', '127.0.0.1', '0.0.0.0']

const isWebposRuntimeHost = (hostname = window.location.hostname) => {
  return WEBPOS_HOSTS.includes(hostname) || WEBPOS_DEBUG_HOSTS.includes(hostname)
}

export const isWebposDebug = (
  hostname = window.location.hostname,
  search = window.location.search,
) => {
  const params = new URLSearchParams(search)
  return WEBPOS_DEBUG_HOSTS.includes(hostname) && params.get('webposDebug') === '1'
}

export const isWebposHost = (
  hostname = window.location.hostname,
  search = window.location.search,
) => {
  return WEBPOS_HOSTS.includes(hostname) || isWebposDebug(hostname, search)
}

export const getWebposToken = (search = window.location.search) => {
  const params = new URLSearchParams(search)
  return params.get('token') || ''
}

export const normalizeWebposInfo = (payload = {}) => {
  const brand = payload.brand || payload.Brank || payload.brank || payload.Brand || ''
  const accessCode = payload.accessCode || payload.accecode || ''
  const language = payload.language || ''
  const deviceId = payload.deviceId || ''
  const token = payload.token || ''

  return {
    isWebpos: true,
    brand,
    accessCode,
    language,
    deviceId,
    token,
  }
}

export const getCachedWebposInfo = () => {
  try {
    const cache = localStorage.getItem(WEBPOS_INFO_KEY)
    return cache ? normalizeWebposInfo(JSON.parse(cache)) : null
  } catch (err) {
    console.error(err)
    return null
  }
}

export const saveCachedWebposInfo = (payload) => {
  const info = normalizeWebposInfo(payload)
  localStorage.setItem(WEBPOS_INFO_KEY, JSON.stringify(info))
  return info
}

export const clearCachedWebposInfo = () => {
  localStorage.removeItem(WEBPOS_INFO_KEY)
  sessionStorage.removeItem(WEBPOS_SESSION_ACTIVE_KEY)
}

export const markWebposSessionActive = () => {
  sessionStorage.setItem(WEBPOS_SESSION_ACTIVE_KEY, '1')
}

export const hasActiveWebposSession = () => {
  return sessionStorage.getItem(WEBPOS_SESSION_ACTIVE_KEY) === '1'
}

export const isWebposMode = () => {
  return isWebposRuntimeHost() && !!getCachedWebposInfo()?.isWebpos
}

export const getWebposDeviceId = () => {
  return isWebposMode() ? getCachedWebposInfo()?.deviceId || '' : ''
}
